import { Attribute } from './Attribute.js';

export const PRIMA_KIDS_REMAINING_MONTHLY_LIMIT_ATTRIBUTE_TYPE = 'PrimaKidsRemainingMonthlyLimit';
export const PRIMA_KIDS_REMAINING_MONTHLY_LIMIT_ATTRIBUTE_ID = 'CreditVS';

/**
 * @property {number} value
 */
export class PrimaKidsRemainingMonthlyLimit extends Attribute {
  constructor({ value }) {
    super();
    this.value = value;
    this.isReadOnly = true;
    this.isHidden = true;
    this.type = PRIMA_KIDS_REMAINING_MONTHLY_LIMIT_ATTRIBUTE_TYPE;
  }
}
